// src/components/WhoWeAre.js
import React from 'react';
import { motion } from 'framer-motion';

const WhoWeAre = () => {
  return (
    <section id="about" style={styles.section}>
      <div style={styles.container}>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          style={styles.sectionTitle}
        >
          ¿Quiénes somos?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ delay: 0.2, duration: 0.6 }}
          style={styles.intro}
        >
          En <strong>Quadramelo</strong>, no solo buscamos productos: 
          construimos soluciones personalizadas para quienes valoran su tiempo, su dinero y su tranquilidad.
        </motion.p>

        <div style={styles.cardsContainer}>
          {/* Card 1: Misión */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ delay: 0.3, duration: 0.6 }}
            style={styles.card}
          >
            <div style={styles.iconCircle}>
              <span style={styles.icon}>🎯</span>
            </div>
            <h3 style={styles.cardTitle}>Nuestra Misión</h3>
            <p style={styles.cardText}>
              Simplificar la experiencia de compra en línea para personas que no tienen tiempo, 
              no saben cómo navegar entre cientos de tiendas o simplemente quieren asegurarse 
              de obtener el mejor precio sin esfuerzo.
            </p>
          </motion.div>

          {/* Card 2: Enfoque */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ delay: 0.4, duration: 0.6 }}
            style={styles.card}
          >
            <div style={styles.iconCircle}>
              <span style={styles.icon}>🔍</span>
            </div>
            <h3 style={styles.cardTitle}>Nuestro Enfoque</h3>
            <p style={styles.cardText}>
              Trabajamos como tu equipo de búsqueda personal. Analizamos precios, 
              verificamos vendedores, comparamos garantías y te entregamos 
              opciones reales, seguras y al mejor costo del mercado.
            </p>
          </motion.div>

          {/* Card 3: Compromiso */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ delay: 0.5, duration: 0.6 }}
            style={styles.card}
          >
            <div style={styles.iconCircle}>
              <span style={styles.icon}>🤝</span>
            </div>
            <h3 style={styles.cardTitle}>Nuestro Compromiso</h3>
            <p style={styles.cardText}>
              Actuamos con total transparencia, ética profesional y dedicación. 
              No cobramos por productos, sino por el valor de nuestro servicio: 
              ahorrarte tiempo, estrés y dinero.
            </p>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ delay: 0.6, duration: 0.6 }}
          style={styles.closing}
        >
          <p style={styles.closingText}>
            <em>Porque en Quadramelo, no vendemos productos… encontramos soluciones.</em>
          </p>
        </motion.div>
      </div>
    </section>
  );
};

const styles = {
  section: {
    padding: '6rem 1rem',
    backgroundColor: '#ffffff',
    position: 'relative',
  },
  container: {
    maxWidth: '1000px',
    margin: '0 auto',
    position: 'relative',
    zIndex: 2,
  },
  sectionTitle: {
    textAlign: 'center',
    fontSize: '2.5rem',
    color: '#212529',
    marginBottom: '1.5rem',
    fontWeight: '800',
    fontFamily: "'Poppins', sans-serif",
  },
  intro: {
    fontSize: '1.2rem',
    color: '#495057',
    lineHeight: 1.8,
    textAlign: 'center',
    marginBottom: '3.5rem',
    maxWidth: '700px',
    margin: '0 auto 3.5rem',
  },
  cardsContainer: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '2.2rem',
    marginBottom: '3rem',
  },
  card: {
    background: 'linear-gradient(145deg, #fafbff, #f5f7ff)',
    borderRadius: '20px',
    padding: '2rem',
    boxShadow: '0 6px 20px rgba(0,0,0,0.05)',
    border: '1px solid #eef1ff',
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  },
  iconCircle: {
    width: '60px',
    height: '60px',
    borderRadius: '16px',
    backgroundColor: 'rgba(67, 97, 238, 0.1)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '1.5rem',
    color: '#4361ee',
    fontSize: '1.8rem',
  },
  cardTitle: {
    fontSize: '1.4rem',
    fontWeight: '700',
    color: '#212529',
    marginBottom: '1rem',
    fontFamily: "'Poppins', sans-serif",
  },
  cardText: {
    fontSize: '1.05rem',
    color: '#5a6268',
    lineHeight: 1.7,
    marginBottom: '0',
  },
  closing: {
    textAlign: 'center',
    marginTop: '2rem',
  },
  closingText: {
    fontSize: '1.25rem',
    color: '#4361ee', // ← color sólido, siempre visible
    fontStyle: 'italic',
    fontWeight: '600',
    fontFamily: "'Poppins', sans-serif",
    textAlign: 'center',
    margin: '0 auto',
    maxWidth: '800px',
    lineHeight: 1.6,
  },
};

export default WhoWeAre;